import { render, staticRenderFns } from "./EllipsisText.vue?vue&type=template&id=0adc27ee&scoped=true&"
import script from "./EllipsisText.vue?vue&type=script&lang=js&"
export * from "./EllipsisText.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisText.vue?vue&type=style&index=0&id=0adc27ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc27ee",
  null
  
)

export default component.exports